import { render, staticRenderFns } from "./tab-switch.vue?vue&type=template&id=67b22c20&scoped=true"
import script from "./tab-switch.vue?vue&type=script&lang=js"
export * from "./tab-switch.vue?vue&type=script&lang=js"
import style0 from "./tab-switch.vue?vue&type=style&index=0&id=67b22c20&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b22c20",
  null
  
)

export default component.exports